
import { ValidationProvider } from 'vee-validate';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { addMonths, subDays } from 'date-fns';
import Helpers from '@/logic/orders/helpers';

@Component({
  components: { ValidationProvider },
})
export default class BaseFieldDateRange extends Vue {
  @Prop({ type: Array, default: [] })
  value!: Date[];

  @Prop({ type: Boolean, default: false })
  nullable!: boolean;

  @Prop({ type: Date, default: () => {} })
  minDate!: Date;

  @Prop({ type: Date, default: () => {} })
  maxDate!: Date;

  get rules(): any {
    return this.$attrs.rules;
  }

  get listeners() {
    // Only take blur and focus from parent, not input
    delete this.$listeners.input;
    return this.$listeners;
  }

  dateFormatter(dates: Date[]): string {
    return dates
      .map((d, i) => {
        // Add a month and subtract a day for end date
        const date = i === 0 ? d : subDays(addMonths(d, 1), 1);
        return Helpers.formatDate(date);
      })
      .join(' - ');
  }

  classNames(errors: any[]): any {
    return {
      'field--has-error': errors.length,
      'field--required': this.hasRule('required'),
    };
  }

  onInput(value: Date[]) {
    const emit = this.nullable && !value ? null : value;
    this.$emit('input', emit);
  }

  clear() {
    this.onInput([]);
  }

  hasRule(rule: string): boolean {
    return this.rules && this.rules.includes(rule);
  }
}
